import moment from 'moment';

export const mapDocumentDetails = (
  omekaData: any,
  foreasDetails: {title: string, id: number},
  ergo_en_title: string,
  collection_en_title: string,
  foreas_en_title: string
// eslint-disable-next-line max-params
) => {
  const documentCollectionUC = omekaData?.['documents:collectionsUniqueCode']?.map((item: any) => item?.['@value']);
  const documentsType = omekaData?.['documents:documentsType']?.map((item: any) => item?.['@value']);
  const documentsLicence = omekaData?.['documents:documentsLicence']?.map((item: any) => item?.['@value']);
  const documentsComments = omekaData?.['documents:documentsComments']?.map((item: any) => item?.['@value']);
  const documentsRelationCollection = omekaData?.['documents:documentsRelationCollection']?.map((item: any) => item?.['display_title']);
  const documentsRelationOrganisation = foreasDetails.title;
  const organisationResourceId = String(foreasDetails.id);
  const documentsRelationProject = omekaData?.['documents:documentsRelationProject']?.map((item: any) => item?.['display_title']);
  const projectResourceId = omekaData?.['documents:documentsRelationProject']?.map((item: any) => item?.['value_resource_id']);
  const collectionResourceId = omekaData?.['documents:documentsRelationCollection']?.map((item: any) => item?.['value_resource_id']);
  const documentsCopyright = omekaData?.['documents:documentsCopyright']?.map((item: any) => item?.['@value']);
  const documentsFrameRate = omekaData?.['documents:documentsFrameRate']?.map((item: any) => item?.['@value']);
  const documentsAspectRatio = omekaData?.['documents:documentsAspectRatio']?.map((item: any) => item?.['@value']);
  const documentsWidth = omekaData?.['documents:documentsWidth']?.map((item: any) => item?.['@value']);
  const documentsHeight = omekaData?.['documents:documentsHeight']?.map((item: any) => item?.['@value']);
  const documentsSize = omekaData?.['documents:documentsSize']?.map((item: any) => item?.['@value']);
  const documentsTechnical = omekaData?.['documents:documentsTechnical']?.map((item: any) => item?.['@value']);
  const documentsSound = omekaData?.['documents:documentsSound']?.map((item: any) => item?.['@value']);
  const documentsColor = omekaData?.['documents:documentsColor']?.map((item: any) => item?.['@value']);
  const documentsDuration = omekaData?.['documents:documentsDuration']?.map((item: any) => item?.['@value']);
  const documentsFormat = omekaData?.['documents:documentsFormat']?.map((item: any) => item?.['@value']);
  const documentsDateCreation = moment(omekaData?.['documents:documentsDateCreation']?.map((item: any) => item?.['@value'])).format('DD/MM/YYYY');
  const documentsEnDescription = omekaData?.['documents:documentsEnDescription']?.map((item: any) => item?.['@value']);
  const documentsDescription = omekaData?.['documents:documentsDescription']?.map((item: any) => item?.['@value']);
  const documentsEnTitle = omekaData?.['documents:documentsEnTitle']?.map((item: any) => item?.['@value']);
  const documentsTitle = omekaData?.['documents:documentsTitle']?.map((item: any) => item?.['@value']);
  const organisationsId = omekaData?.['documents:organisationsId']?.map((item: any) => item?.['@value']);
  const documentsUniqueCode = omekaData?.['documents:documentsUniqueCode']?.map((item: any) => item?.['@value']);
  const documentsYtTitle = omekaData?.['documents:documentsVimeoYtTitle']?.map((item: any) => item?.['@value']);
  const documentsYtUrl = {
    url: omekaData?.['documents:documentsVimeoYtUrl']?.map((item: any) => item?.['@value']),
    label: omekaData?.['documents:documentsVimeoYtUrl']?.map((item: any) => item?.['@value']),
    externalLink: true
  };
  const documentsRelationProjectEn = ergo_en_title;
  const documentsRelationCollectionEn = collection_en_title;
  const documentsRelationOrganisationEn = foreas_en_title;

  return {
    documentCollectionUC,
    documentsType,
    documentsLicence,
    documentsComments,
    documentsRelationCollection,
    documentsRelationOrganisation,
    documentsRelationProject,
    documentsCopyright,
    documentsFrameRate,
    documentsAspectRatio,
    documentsWidth,
    documentsHeight,
    documentsSize,
    documentsTechnical,
    documentsSound,
    documentsColor,
    documentsDuration,
    documentsFormat,
    documentsDateCreation,
    documentsEnDescription,
    documentsDescription,
    documentsEnTitle,
    documentsTitle,
    organisationsId,
    documentsUniqueCode,
    projectResourceId,
    organisationResourceId,
    collectionResourceId,
    documentsYtTitle,
    documentsYtUrl,
    documentsRelationProjectEn,
    documentsRelationCollectionEn,
    documentsRelationOrganisationEn
  };
};

export const documentDetails = [
  [
    'documentsUniqueCode',
    'documentsType',
    'documentsDescription',
    'documentsEnDescription',
    'documentsFormat',
    'documentsDuration',
    'documentsDateCreation',
    'documentsColor',
    'documentsSound',
    'documentsYtTitle'
  ],
  [
    'documentsTechnical',
    'documentsSize',
    'documentsHeight',
    'documentsWidth',
    'documentsFrameRate',
    'documentsAspectRatio',
    'documentsCopyright',
    'documentsLicence',
    '',
    '',
    'documentsComments',
    'documentsYtUrl'
  ],
];

export const documentInfo = [
  ['documentsEnTitle', 'documentsTitle'],
  ['documentsRelationCollection', 'documentsRelationOrganisation'],
];